import {observer_mgl} from "mobx-graphlink";
import React from "react";
import {Button, Row} from "react-vcomponents";
import {RunInAction} from "web-vcore";
import {store} from "../../Store/index.js";
import {zIndexes} from "../../Utils/UI/ZIndexes.js";

//const navBar_android_height = 50;

export const NavBar_Android = observer_mgl(()=>{
	return (
		<nav className="NavBar_Android" style={{
			position: "relative", zIndex: zIndexes.navBar,
			//boxShadow: colors.navBarBoxShadow,
			background: "rgba(0,0,0,1)",
		}}>
			<Row center style={{height: 50, justifyContent: "space-around"}}>
				{/*<NavBar_Android_Button page="home" subpage="home" text="Home"/>*/}
				<NavBar_Android_Button page="journal" text="Journal"/>
				<NavBar_Android_Button page="engine" subpage="config" text="Config"/>
				<NavBar_Android_Button page="engine" subpage="journey" text="Engine"/>
				<NavBar_Android_Button page="stats" text="Stats"/>
				<NavBar_Android_Button page="maps" subpage="maps" text="Maps"/>
				<NavBar_Android_Button page="settings" text="Settings"/>
			</Row>
		</nav>
	);
});

const NavBar_Android_Button = ((props: {page: string, subpage?: string, text: string})=>{
	const {page, subpage, text} = props;
	return (
		<Button text={text} style={{width: 50, height: 50}} onClick={()=>{
			RunInAction("NavBar_Android_Button.onClick", ()=>{
				store.main.page = page;
				if (subpage) store.main[page].subpage = subpage;
				//if (journeyTab) store.main.engine.journey.tab = journeyTab;
			});
		}}/>
	);
});